import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const TextSkeleton = ({ fontSize = '1rem', width = '100%' }) => {
  return <Skeleton variant="text" sx={{ fontSize }} width={width} />;
};

export default TextSkeleton;
